import { render, staticRenderFns } from "./thirds_config_detail.vue?vue&type=template&id=ad21dcb8&scoped=true"
import script from "./thirds_config_detail.vue?vue&type=script&lang=js"
export * from "./thirds_config_detail.vue?vue&type=script&lang=js"
import style0 from "./thirds_config_detail.vue?vue&type=style&index=0&id=ad21dcb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad21dcb8",
  null
  
)

export default component.exports